let draftRowCounter = 0;

export function createDraftId(prefix) {
  draftRowCounter += 1;
  return `${prefix}-${draftRowCounter}`;
}

export function normalizeOption(option = {}) {
  return {
    key: String(option?.key ?? option?.id ?? option?.value ?? ""),
    label: option?.label ?? option?.name ?? option?.key ?? "",
  };
}

export function normalizeCollection(collection) {
  if (Array.isArray(collection)) {return collection;}
  if (collection && typeof collection === "object") {return Object.values(collection);}
  return [];
}

export function mergeEmailRow(baseRow = {}, fallbackRow = {}) {
  return {
    ...fallbackRow,
    ...baseRow,
    email_type:
      baseRow?.email_type ?? baseRow?.emailType ?? fallbackRow?.email_type ?? fallbackRow?.emailType,
  };
}

export function mergePhoneRow(baseRow = {}, fallbackRow = {}) {
  return {
    ...fallbackRow,
    ...baseRow,
    contact_label:
      baseRow?.contact_label ?? baseRow?.contactLabel ?? fallbackRow?.contact_label ?? fallbackRow?.contactLabel,
    display: baseRow?.display ?? fallbackRow?.display ?? fallbackRow?.value ?? fallbackRow?.phone,
  };
}

export function normalizeText(value) {
  return (value ?? "").trim();
}

export function getEmailTypeKey(email) {
  return String(email?.emailType ?? email?.email_type ?? "");
}

export function getEmailValue(email) {
  return email?.email ?? "";
}

export function getPhoneValue(phone) {
  return phone?.display ?? phone?.value ?? phone?.phone ?? "";
}

export function getPhoneTypeKey(phone) {
  return String(phone?.contact_label ?? phone?.contactLabel ?? "");
}

export function normalizeEditablePhoneValue(value) {
  const normalizedValue = String(value ?? "").trim();
  if (normalizedValue.startsWith("+1 ")) {return normalizedValue.slice(3);}
  if (normalizedValue.startsWith("+1")) {return normalizedValue.slice(2).trim();}
  return normalizedValue;
}

export function getOptionLabelByKey(options = [], key) {
  return options.find((option) => option.key === String(key))?.label ?? "";
}

export function getPhoneDisplayLabel(phone, options = []) {
  const rawLabel = getPhoneTypeKey(phone).trim();
  if (!rawLabel) {return "Phone";}
  return options.find((option) => option.key === rawLabel || option.label === rawLabel)?.label ?? rawLabel;
}

export function createEmailDraftRow(email = null) {
  return {
    localId: createDraftId("email"),
    id: email?.id ?? null,
    typeKey: email ? getEmailTypeKey(email) : "",
    value: email ? getEmailValue(email) : "",
    originalTypeKey: email ? getEmailTypeKey(email) : "",
    originalValue: email ? getEmailValue(email) : "",
    mode: email ? "edit" : "add",
  };
}

export function createPhoneDraftRow(phone = null) {
  return {
    localId: createDraftId("phone"),
    id: phone?.id ?? null,
    typeKey: phone ? getPhoneTypeKey(phone) : "",
    value: phone ? normalizeEditablePhoneValue(getPhoneValue(phone)) : "",
    originalTypeKey: phone ? getPhoneTypeKey(phone) : "",
    originalValue: phone ? normalizeEditablePhoneValue(getPhoneValue(phone)) : "",
    mode: phone ? "edit" : "add",
  };
}

export function isDraftChanged(row) {
  if (row.mode === "add") {
    return Boolean(normalizeText(row.typeKey) || normalizeText(row.value));
  }

  return (
    normalizeText(row.typeKey) !== normalizeText(row.originalTypeKey) ||
    normalizeText(row.value) !== normalizeText(row.originalValue)
  );
}

export function buildSelectableOptions(options = [], rows = [], currentRow) {
  const unavailableKeys = new Set(
    rows
      .filter((row) => row.localId !== currentRow.localId)
      .map((row) => row.typeKey)
      .filter(Boolean)
  );

  return options.filter(
    (option) => option.key === currentRow.typeKey || !unavailableKeys.has(option.key)
  );
}
